module.exports = __webpack_public_path__ + "img/hero-shape.a4c310e2.png";